import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { TemplateMessage } from "./ChatHistoryWindow";
import { getTenantTimezone } from "../utils/dateUtils";

dayjs.extend(utc);
dayjs.extend(timezone);

const parseMessage = (message) => {
  if (!message) return "";
  let formatted = message.replace(
    /```(.+?)```/gs,
    "<pre><code>$1</code></pre>",
  );
  formatted = formatted.replace(
    /(^|\n)((?:\s*[\*\-]\s+.+\n?)+)/g,
    (match, p1, listBlock) => {
      const items = listBlock.replace(/^\s*[\*\-]\s+(.+)$/gm, "<li>$1</li>");
      return p1 + "<ul>" + items + "</ul>";
    },
  );
  formatted = formatted.replace(
    /(^|\n)((?:\s*\d+\.\s+.+\n?)+)/g,
    (match, p1, listBlock) => {
      const items = listBlock.replace(/^\s*\d+\.\s+(.+)$/gm, "<li>$1</li>");
      return p1 + "<ol>" + items + "</ol>";
    },
  );
  formatted = formatted.replace(
    /^(\s*>\s+)(.+)$/gm,
    "<blockquote>$2</blockquote>",
  );
  formatted = formatted
    .replace(/_([^_]+)_/g, "<i>$1</i>")
    .replace(/\*([^\*]+)\*/g, "<b>$1</b>")
    .replace(/~([^~]+)~/g, "<s>$1</s>")
    .replace(/`([^`]+)`/g, "<code>$1</code>");
  formatted = formatted.replace(/\n/g, "<br>");
  return formatted;
};

// One chat message — a bubble, or a TemplateMessage preview when the
// message carries a rendered template. Extracted out of ChatWindow.js's
// inline per-message JSX (pure lift, no behavior change) so both
// ChatWindow.js (the Chat tab) and CombinedActivityWindow.js (the All
// tab's merged chat+call feed) share one rendering implementation instead
// of duplicating it — see interleave-chat-call-activity's design.md
// Decision 4.
const ChatMessageRow = ({ msg }) => {
  const isSent = msg.utype === "SPT";

  if (msg.template) {
    return <TemplateMessage message={msg} />;
  }

  return (
    <Box
      mb={1.5}
      display="flex"
      flexDirection={isSent ? "row-reverse" : "row"}
      alignItems="flex-end"
      gap={1}
    >
      <Box
        sx={{
          maxWidth: { xs: "85%", md: "65%" },
          px: 1.75,
          py: 1,
          borderRadius: isSent
            ? "18px 18px 4px 18px"
            : "18px 18px 18px 4px",
          bgcolor: isSent ? "#dcf8c6" : "#ffffff",
          boxShadow: isSent
            ? "0 1px 4px rgba(0,0,0,0.08)"
            : "0 1px 3px rgba(0,0,0,0.08)",
          wordBreak: "break-word",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.875rem",
            lineHeight: 1.5,
            color: "#1a1a2e",
          }}
          dangerouslySetInnerHTML={{
            __html: parseMessage(msg.message),
          }}
        />
        <Box
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap={0.5}
          mt={0.4}
        >
          <Typography sx={{ fontSize: "0.65rem", color: "#888" }}>
            {dayjs(msg.timestamp).tz(getTenantTimezone()).format("hh:mm A")}
          </Typography>
          {isSent && (
            <Typography sx={{ fontSize: "0.65rem", color: "#4fc3f7" }}>
              ✓✓
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ChatMessageRow;
